import React from 'react'

interface NavigationItem {
  id: string
  label: string
  icon?: React.ReactNode
  onClick?: () => void
  active?: boolean
}

interface NavigationProps {
  items: NavigationItem[]
  orientation?: 'horizontal' | 'vertical'
}

export const Navigation: React.FC<NavigationProps> = ({ 
  items, 
  orientation = 'horizontal' 
}) => {
  return (
    <nav className={`app-navigation app-navigation--${orientation}`}>
      <ul className="navigation-list">
        {items.map((item) => (
          <li key={item.id} className="navigation-item">
            <button
              className={`navigation-button ${item.active ? 'navigation-button--active' : ''}`}
              onClick={item.onClick}
            >
              {item.icon && <span className="navigation-icon">{item.icon}</span>}
              <span className="navigation-label">{item.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  )
}